<section class="wrapper">
    <header>
      <h1>{{ 'pages.services-state.list.header' | translate }}</h1>
      <div class="header-actions">
        <button class="bciti-button bciti-button--blue-inversed" (click)="openEditStatusesDialog()">
            {{ 'pages.services-state.list.button.edit-statuses' | translate }}
          </button>
        <button class="bciti-button bciti-button--blue-inversed" (click)="openEditCategoriesDialog()">
          {{ 'pages.services-state.list.button.edit-categories' | translate }}
        </button>
        <button [routerLink]="['/services/new']" class="bciti-button bciti-button--blue">
          {{ 'pages.services-state.list.button.add-service' | translate }}
        </button>
      </div>
    </header>
    <section class="content loading" *ngIf="loading">
      <mat-progress-spinner mode="indeterminate" diameter="40"></mat-progress-spinner>
    </section>
    <section class="content" *ngIf="!loading">
      <app-service-state-table></app-service-state-table>
    </section>
</section>
